export interface ISkeletonBoxPresenterConfig {
    box?: HTMLDivElement;
}

export class SkeletonBoxPresenter {
    protected box: HTMLDivElement | undefined;

    public constructor (config: ISkeletonBoxPresenterConfig) {
        this.box = config.box;
    }

    public getBoxWidth (): number {
        return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }

    public getBoxLeft (): number {
        let element: HTMLElement | undefined = this.box;
        let left: number = 0;

        if (!element) {
            return 0;
        }

        do {
            if (!isNaN(element.offsetLeft)) {
                left = left + element.offsetLeft;
            }

            if (!element.offsetParent) {
                return left * -1;
            }

            element = element.offsetParent as HTMLElement;
        } while (element);

        return left * -1;
    }
}
